module.exports = __webpack_public_path__ + "media/application/images/tciot-logo-3bd83c11bb28d644a7f9ffcda14a837d.jpg";